export default {"src":"/_next/static/media/academicLogo2.43ead5d0.svg","height":48,"width":213,"blurWidth":0,"blurHeight":0};